import { typeCreatorV2 } from '../../../redux/utils/common';

export const SET_PRODUCT_LIST: string = typeCreatorV2(
  'HomeReducer',
  'SetProductList'
);

export const SET_LATEST_NEWS: string = typeCreatorV2(
  'HomeReducer',
  'SetLatestNews'
);

export const SET_CATEGORY: string = typeCreatorV2('HomeReducer', 'SetCategory');

export const SET_TOPIC_LIST: string = typeCreatorV2('HomeReducer', 'SetTopic');

export const SET_CITY: string = typeCreatorV2('HomeReducer', 'SetCity');

export const SET_FILTERS_SELECTION: string = typeCreatorV2(
  'HomeReducer',
  'SetFiltersSelection'
);

export const INSERT_PRODUCT_FILTER: string = typeCreatorV2(
  'HomeReducer',
  'InsertProductFilter'
);

export const SUBSCRIBE_TO_NEWS_LETTER: string = typeCreatorV2(
  'HomeReducer',
  'SubscribeToNewsLetter'
);

export const SET_TOPIC_LIST_BY_CATEGORY: string = typeCreatorV2(
  'HomeReducer',
  'SetTopicByCategory'
);
